import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sofax/content-circle.svg")